<script>
    import { push } from 'svelte-spa-router'
    import { fly } from 'svelte/transition'
    export let title
</script>

<div class="header">
    <div class="logo" on:click={() => push('/')}></div>
    <p in:fly="{{ x: -20, duration: 500 }}">{title}</p>
	<p class="version-number">v1.4</p>
</div>

<style>
    .header {
		align-self: end;
		margin: 0 6%;
	}
	.header .logo {
		height: 24px;
		width: 64px;
		background: url('/assets/oks-logo.svg');
		background-repeat: no-repeat;
		float: left;
		border-right: 2px solid #323336;
		padding-right: 20px;
        cursor: pointer;
	}
	.header p {
		float: left;
		margin: 3px 20px;
		font-family: var(--font);
		font-weight: 500;
		font-size: 0.9em;
	}
	.header .version-number {
		color: var(--content-secondary);
		transition: 0.2s;
		float: left;
		margin-left: 0;
	}
</style>